import React from 'react';
import errorBoundary from '@ifeng-fe/errorBoundary';
import PropTypes from 'prop-types';
import { getPhtvSoleNewsList } from '../../../../services/api';
import FeedItem from './feedItem';
import styles from './index.css';

class FeedTabList extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
        setCurrentYear: PropTypes.func,
    };

    state = {
        currentYear: this.props.content.currentYear,
        liveFeedData: this.props.content.liveFeedData,
        isClickTab: false,
    };

    isOnloadMoreData = true;
    livePageNum = 1;

    componentDidMount() {
        // this.scrollPageHandle();
    }

    scrollPageHandle = () => {
        let isScrollEnd = false;

        window.addEventListener(
            'scroll',
            () => {
                const scrollHeight = Math.max(document.documentElement.scrollHeight, document.body.scrollHeight);
                const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
                const clientHeight =
                    window.innerHeight || Math.min(document.documentElement.clientHeight, document.body.clientHeight);

                if (clientHeight + scrollTop >= scrollHeight - 115) {
                    if (!isScrollEnd) {
                        this.livePageNum = this.livePageNum + 1;
                        this.getMoreData();
                        isScrollEnd = true;
                    }
                } else {
                    isScrollEnd = false;
                }
            },
            true,
        );
    };

    getMoreData = async (year, num) => {
        const { content } = this.props;
        const { currentYear, liveFeedData } = this.state;
        const columnId = content.columnId;
        const liveYear = year || currentYear;
        const livePageNum = num || this.livePageNum;

        const result = await getPhtvSoleNewsList(columnId, liveYear, livePageNum);

        if (result && result.list && result.list.length > 0) {
            this.setState(
                {
                    liveFeedData: liveFeedData.concat(result.list),
                },
                () => {
                    this.setState({
                        isClickTab: false,
                    });
                },
            );
        } else {
            this.setState({
                isClickTab: false,
            });
        }
    };

    tabClickHandle = tabName => {
        this.props.setCurrentYear(tabName);
        this.livePageNum = 1;
        this.setState(
            {
                currentYear: tabName,
                liveFeedData: [],
                isClickTab: true,
            },
            () => {
                this.getMoreData(tabName, 1);
            },
        );
    };

    render() {
        const { content } = this.props;
        const { currentYear, liveFeedData, isClickTab } = this.state;
        const columnId = content.columnId;

        return (
            <div className={styles.feedTabBox}>
                <div className={styles.feedTab}>
                    {content.yearList.map(item => {
                        return (
                            <div
                                key={item}
                                className={`${styles.feedTabItem}
                                ${item === currentYear ? styles.active : ''}`}
                                onClick={this.tabClickHandle.bind(this, item)}>
                                {item}
                            </div>
                        );
                    })}
                </div>
                <div className={`${styles.feedBox} ${isClickTab ? styles.minChangeHeight : ''}`}>
                    {liveFeedData.map((item, index) => {
                        const feedItemData = {
                            base62Id: item.documentId,
                            imageUrl: item.thumbnail || (item.imageList && item.imageList[0]) || '',
                            title: item.title,
                            time: item.updateTime,
                            comment: item.commentsall,
                            currentYear,
                            columnId,
                            isCurrentItem: item.documentId === content.base62Id,
                        };

                        return <FeedItem key={index} content={feedItemData} />;
                    })}
                </div>
            </div>
        );
    }
}

export default errorBoundary(FeedTabList);
